/**
 * Main JavaScript entry point
 * Initializes all modules
 */

(function () {
  function loadModule(path) {
    const script = document.createElement('script');
    script.src = path;
    script.async = false;
    document.head.appendChild(script);
    return script;
  }

  loadModule('/js/modules/captcha.js');
  loadModule('/js/modules/styling.js');
  loadModule('/js/modules/navigation.js');

  document.addEventListener('DOMContentLoaded', function () {
    if (window.initializeCaptcha) window.initializeCaptcha();
    if (window.initializeStyling) window.initializeStyling();
    if (window.initializeNavigation) window.initializeNavigation();

    if (document.getElementById('fileDropArea')) {
      loadModule('/js/modules/fileUpload.js').onload = function () {
        if (window.initializeFileUpload) window.initializeFileUpload();
      };
    }

    if (document.querySelector('.contact-form form')) {
      loadModule('/js/modules/formValidation.js').onload = function () {
        if (window.initializeFormValidation) window.initializeFormValidation();
      };
    }
  });
})();
